import { apiClient } from "../common/axiosInstance";
import { handleAxiosError } from "../common/handleAxiosError";

export const getAllUsers = async (state: number) => {
  try {
    const response = await apiClient.get(`/users?state=${state}`);
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al obtener los usuarios");
  }
}